export const connectionsStr = `a,c,d\ne,f,g\nc,e\ne,k\nb,a\na,q\ne,m\ne,l\ng,i\ne,f\nk,n\ne,t\nv,a\ne,u\no,i\ng,h\nf,g\nn,p\ng,j\no,h\nn,o\na,w\na,y\na,z1\nv,z1\n`;
